import { useMemo } from 'react';

import { CAR_GROSS_WEIGHTS } from '../constants';

export const useCarGrossWeightList = () => {
  return useMemo(() => ([
    {
      value: "≤ 3.5t",
      key: CAR_GROSS_WEIGHTS["3500Kg"], // kilograms
    },
    {
      value: "≤ 7.5t",
      key: CAR_GROSS_WEIGHTS["7500kg"],
    },
    {
      value: "≤ 12t",
      key: CAR_GROSS_WEIGHTS["12000Kg"],
    },
    {
      value: "≤ 18t",
      key: CAR_GROSS_WEIGHTS["18000Kg"],
    },
    {
      value: "≤ 32t",
      key: CAR_GROSS_WEIGHTS["32000Kg"],
    },
    {
      value: "≤ 40t",
      key: CAR_GROSS_WEIGHTS["40000Kg"],
    },
  ]), []);
};
